export default function getCapitalizedText(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export const formatQueryParam = (name: string): string =>
    name.toLowerCase().replace(/ /g, '_');

const formatNumber = (value: number, isPercentage: boolean): string => {
    if (value === 0) {
        return '0';
    }
    return isPercentage ? `${value.toFixed(2)}%` : value.toLocaleString();
};

export const parseMetricToString = (
    value: number | string | undefined | null,
    isPercentage: boolean,
): string => {
    let parsedValue = typeof value === 'string' ? Number(value) : value;

    if (typeof parsedValue === 'number') {
        return formatNumber(parsedValue, isPercentage);
    } else {
        return '-';
    }
};

export const truncateString = (heading: string, truncationCount: number) =>
    heading?.length > truncationCount
        ? heading.slice(0, truncationCount) + '...'
        : heading;
